/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  QrCancelResponseDto,
  QrCheckInResponseDto,
  QrScanResponseDto,
  RealtimeResponseDto,
  ReceptionExitDto,
  ReceptionManagerDto,
  ReceptionModeControllerCheckInByQrV1Params,
  ReceptionModeControllerGetRealtimeV1Params,
  ReceptionModeControllerScanQrV1Params,
  ReceptionModeControllerSearchV1Params,
  ReceptionSearchItemDto,
  ReceptionStateResponseDto
} from '../model';

import { axiosInstance } from '../../axiosInstance';




/**
 * 관리자 비밀번호 확인 후 리셉션 모드 해제
 * @summary 리셉션 모드 이탈
 */
export const receptionModeControllerExitV1 = (
    receptionExitDto: ReceptionExitDto,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<void>(
      {url: `/v1/reception/checkin/exit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: receptionExitDto, signal
    },
      );
    }
  


export const getReceptionModeControllerExitV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerExitV1>>, TError,{data: ReceptionExitDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerExitV1>>, TError,{data: ReceptionExitDto}, TContext> => {

const mutationKey = ['receptionModeControllerExitV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receptionModeControllerExitV1>>, {data: ReceptionExitDto}> = (props) => {
          const {data} = props ?? {};

          return  receptionModeControllerExitV1(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceptionModeControllerExitV1MutationResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerExitV1>>>
    export type ReceptionModeControllerExitV1MutationBody = ReceptionExitDto
    export type ReceptionModeControllerExitV1MutationError = void

    /**
 * @summary 리셉션 모드 이탈
 */
export const useReceptionModeControllerExitV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerExitV1>>, TError,{data: ReceptionExitDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receptionModeControllerExitV1>>,
        TError,
        {data: ReceptionExitDto},
        TContext
      > => {
      return useMutation(getReceptionModeControllerExitV1MutationOptions(options), queryClient);
    }
    /**
 * 담당자 이름 + 관리자 비밀번호로 담당자 변경
 * @summary 체크인 담당자 변경
 */
export const receptionModeControllerChangeManagerV1 = (
    receptionManagerDto: ReceptionManagerDto,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ReceptionStateResponseDto>(
      {url: `/v1/reception/checkin/manager`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: receptionManagerDto, signal
    },
      );
    }
  


export const getReceptionModeControllerChangeManagerV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerChangeManagerV1>>, TError,{data: ReceptionManagerDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerChangeManagerV1>>, TError,{data: ReceptionManagerDto}, TContext> => {

const mutationKey = ['receptionModeControllerChangeManagerV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receptionModeControllerChangeManagerV1>>, {data: ReceptionManagerDto}> = (props) => {
          const {data} = props ?? {};

          return  receptionModeControllerChangeManagerV1(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceptionModeControllerChangeManagerV1MutationResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerChangeManagerV1>>>
    export type ReceptionModeControllerChangeManagerV1MutationBody = ReceptionManagerDto
    export type ReceptionModeControllerChangeManagerV1MutationError = void

    /**
 * @summary 체크인 담당자 변경
 */
export const useReceptionModeControllerChangeManagerV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerChangeManagerV1>>, TError,{data: ReceptionManagerDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receptionModeControllerChangeManagerV1>>,
        TError,
        {data: ReceptionManagerDto},
        TContext
      > => {
      return useMutation(getReceptionModeControllerChangeManagerV1MutationOptions(options), queryClient);
    }
    /**
 * 대회 또는 회차의 체크인 진행 현황
 * @summary 실시간 진행 현황
 */
export const receptionModeControllerGetRealtimeV1 = (
    params?: ReceptionModeControllerGetRealtimeV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<RealtimeResponseDto>(
      {url: `/v1/reception/checkin/realtime`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getReceptionModeControllerGetRealtimeV1QueryKey = (params?: ReceptionModeControllerGetRealtimeV1Params,) => {
    return [
    `/v1/reception/checkin/realtime`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getReceptionModeControllerGetRealtimeV1QueryOptions = <TData = Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError = void>(params?: ReceptionModeControllerGetRealtimeV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceptionModeControllerGetRealtimeV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>> = ({ signal }) => receptionModeControllerGetRealtimeV1(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceptionModeControllerGetRealtimeV1QueryResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>>
export type ReceptionModeControllerGetRealtimeV1QueryError = void


export function useReceptionModeControllerGetRealtimeV1<TData = Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError = void>(
 params: undefined |  ReceptionModeControllerGetRealtimeV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>,
          TError,
          Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceptionModeControllerGetRealtimeV1<TData = Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError = void>(
 params?: ReceptionModeControllerGetRealtimeV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>,
          TError,
          Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceptionModeControllerGetRealtimeV1<TData = Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError = void>(
 params?: ReceptionModeControllerGetRealtimeV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 실시간 진행 현황
 */

export function useReceptionModeControllerGetRealtimeV1<TData = Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError = void>(
 params?: ReceptionModeControllerGetRealtimeV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerGetRealtimeV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceptionModeControllerGetRealtimeV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 이름/전화 뒤4자리/배번호로 참가자 검색 (대회 또는 회차 스코프)
 * @summary 참가자 검색
 */
export const receptionModeControllerSearchV1 = (
    params: ReceptionModeControllerSearchV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ReceptionSearchItemDto[]>(
      {url: `/v1/reception/checkin/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getReceptionModeControllerSearchV1QueryKey = (params?: ReceptionModeControllerSearchV1Params,) => {
    return [
    `/v1/reception/checkin/search`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getReceptionModeControllerSearchV1QueryOptions = <TData = Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError = void>(params: ReceptionModeControllerSearchV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceptionModeControllerSearchV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>> = ({ signal }) => receptionModeControllerSearchV1(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceptionModeControllerSearchV1QueryResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>>
export type ReceptionModeControllerSearchV1QueryError = void


export function useReceptionModeControllerSearchV1<TData = Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError = void>(
 params: ReceptionModeControllerSearchV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receptionModeControllerSearchV1>>,
          TError,
          Awaited<ReturnType<typeof receptionModeControllerSearchV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceptionModeControllerSearchV1<TData = Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError = void>(
 params: ReceptionModeControllerSearchV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receptionModeControllerSearchV1>>,
          TError,
          Awaited<ReturnType<typeof receptionModeControllerSearchV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceptionModeControllerSearchV1<TData = Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError = void>(
 params: ReceptionModeControllerSearchV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 참가자 검색
 */

export function useReceptionModeControllerSearchV1<TData = Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError = void>(
 params: ReceptionModeControllerSearchV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerSearchV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceptionModeControllerSearchV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * QR 토큰으로 참가자 정보 조회. contestId/sessionId 전달 시 QR의 실제 소속과 일치하는지 검증
 * @summary QR 스캔 조회
 */
export const receptionModeControllerScanQrV1 = (
    token: string,
    params?: ReceptionModeControllerScanQrV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<QrScanResponseDto>(
      {url: `/v1/reception/checkin/qr/${token}`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getReceptionModeControllerScanQrV1QueryKey = (token: string,
    params?: ReceptionModeControllerScanQrV1Params,) => {
    return [
    `/v1/reception/checkin/qr/${token}`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getReceptionModeControllerScanQrV1QueryOptions = <TData = Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError = void>(token: string,
    params?: ReceptionModeControllerScanQrV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReceptionModeControllerScanQrV1QueryKey(token,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>> = ({ signal }) => receptionModeControllerScanQrV1(token,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReceptionModeControllerScanQrV1QueryResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>>
export type ReceptionModeControllerScanQrV1QueryError = void


export function useReceptionModeControllerScanQrV1<TData = Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError = void>(
 token: string,
    params: undefined |  ReceptionModeControllerScanQrV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>,
          TError,
          Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceptionModeControllerScanQrV1<TData = Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError = void>(
 token: string,
    params?: ReceptionModeControllerScanQrV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>,
          TError,
          Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReceptionModeControllerScanQrV1<TData = Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError = void>(
 token: string,
    params?: ReceptionModeControllerScanQrV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary QR 스캔 조회
 */

export function useReceptionModeControllerScanQrV1<TData = Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError = void>(
 token: string,
    params?: ReceptionModeControllerScanQrV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof receptionModeControllerScanQrV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReceptionModeControllerScanQrV1QueryOptions(token,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * QR 토큰으로 체크인 처리 (logId 반환, 5초 취소용). contestId/sessionId 전달 시 QR의 실제 소속과 일치하는지 검증
 * @summary QR 체크인 처리
 */
export const receptionModeControllerCheckInByQrV1 = (
    token: string,
    params?: ReceptionModeControllerCheckInByQrV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<QrCheckInResponseDto>(
      {url: `/v1/reception/checkin/qr/${token}/checkin`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getReceptionModeControllerCheckInByQrV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerCheckInByQrV1>>, TError,{token: string;params?: ReceptionModeControllerCheckInByQrV1Params}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerCheckInByQrV1>>, TError,{token: string;params?: ReceptionModeControllerCheckInByQrV1Params}, TContext> => {

const mutationKey = ['receptionModeControllerCheckInByQrV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receptionModeControllerCheckInByQrV1>>, {token: string;params?: ReceptionModeControllerCheckInByQrV1Params}> = (props) => {
          const {token,params} = props ?? {};

          return  receptionModeControllerCheckInByQrV1(token,params,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceptionModeControllerCheckInByQrV1MutationResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerCheckInByQrV1>>>
    
    export type ReceptionModeControllerCheckInByQrV1MutationError = void

    /**
 * @summary QR 체크인 처리
 */
export const useReceptionModeControllerCheckInByQrV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerCheckInByQrV1>>, TError,{token: string;params?: ReceptionModeControllerCheckInByQrV1Params}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receptionModeControllerCheckInByQrV1>>,
        TError,
        {token: string;params?: ReceptionModeControllerCheckInByQrV1Params},
        TContext
      > => {
      return useMutation(getReceptionModeControllerCheckInByQrV1MutationOptions(options), queryClient);
    }
    /**
 * 체크인 로그 기준 5초 이내 실행취소 (서버 시간 재검증)
 * @summary 5초 실행취소
 */
export const receptionModeControllerCancelRecentQrV1 = (
    logId: number,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<QrCancelResponseDto>(
      {url: `/v1/reception/checkin/${logId}/cancel`, method: 'POST', signal
    },
      );
    }
  


export const getReceptionModeControllerCancelRecentQrV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerCancelRecentQrV1>>, TError,{logId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerCancelRecentQrV1>>, TError,{logId: number}, TContext> => {

const mutationKey = ['receptionModeControllerCancelRecentQrV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receptionModeControllerCancelRecentQrV1>>, {logId: number}> = (props) => {
          const {logId} = props ?? {};

          return  receptionModeControllerCancelRecentQrV1(logId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ReceptionModeControllerCancelRecentQrV1MutationResult = NonNullable<Awaited<ReturnType<typeof receptionModeControllerCancelRecentQrV1>>>
    
    export type ReceptionModeControllerCancelRecentQrV1MutationError = void

    /**
 * @summary 5초 실행취소
 */
export const useReceptionModeControllerCancelRecentQrV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receptionModeControllerCancelRecentQrV1>>, TError,{logId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receptionModeControllerCancelRecentQrV1>>,
        TError,
        {logId: number},
        TContext
      > => {
      return useMutation(getReceptionModeControllerCancelRecentQrV1MutationOptions(options), queryClient);
    }
    